export default __webpack_public_path__ + "static/media/seasons.a7e2e1a5.svg";